import { usePreInstallGcr } from "@/api/useIntegrations"
import { Breadcrumb, Form, Link } from "@/atoms"
import { INTEGRATION_VENDORS } from "@/const/vendors-constants"
import { useTranslation } from "@/hooks/useTranslation"
import { Heading } from "@/molecules/Heading"
import { HeaderPage } from "@/organisms/HeaderPage"
import { FormGcr } from "@/pages/IntegrationsPage/components/molecules/FormGcr"
import { GcrServiceAccount } from "@/pages/IntegrationsPage/components/molecules/GcrServiceAccount"
import { gcrGrantTarget } from "@/pages/IntegrationsPage/helpers/gcr"
import { useGcrAPI } from "@/pages/IntegrationsPage/hooks/useGcrAPI"
import { useIntegration } from "@/pages/IntegrationsPage/hooks/useIntegration"
import { PageWithBreadcrumbTemplate } from "@/templates/PageWithBreadcrumbTemplate"
import { ConnectIntegrationFooter } from "../ConnectIntegrationPage/ConnectIntegrationFooter"

import styles from "./GcrIntegrationPage.module.scss"

export const GcrIntegrationPage = () => {
  const { t } = useTranslation()
  const vendor = INTEGRATION_VENDORS.gcr
  const [_, { onRemove: _onRemove, ...formProps }] = useIntegration({ vendor })
  const gcrApi = useGcrAPI(formProps)
  const { response, isError, isFetching, refetch } = usePreInstallGcr()
  const title = t("integrations.gcr.title")
  const target = gcrGrantTarget({
    locations: Form.useWatch("locations", formProps.form),
    repositories: Form.useWatch("repositories", formProps.form),
    projectId: Form.useWatch("projectId", formProps.form)
  })

  return (
    <PageWithBreadcrumbTemplate
      full
      header={
        <HeaderPage
          title={
            <Breadcrumb
              items={[
                {
                  title: (
                    <Link to="/integrations">
                      {t("navigation.integrations")}
                    </Link>
                  )
                },
                {
                  title: (
                    <Link to={formProps.getBackToIntegrationUrl()}>
                      Google Artifact Registry
                    </Link>
                  )
                },
                { title }
              ]}
            />
          }
        />
      }
      footer={
        <ConnectIntegrationFooter
          disabled={!formProps.isDirty}
          isLoading={gcrApi.isPending}
          okText={t("integrations.gcr.form.buttons.connect")}
          okProps={{ form: gcrApi.formId, htmlType: "submit" }}
          onCancel={() => formProps.backToIntegration()}
        />
      }
    >
      <div className={styles.title}>
        <Heading level={4} title={title} />
      </div>
      <GcrServiceAccount
        email={response?.data?.serviceAccountEmail}
        target={target}
        failed={isError && !isFetching}
        onRetry={() => refetch()}
      />
      <Heading level={6} title={t("integrations.gcr.form.title")} />
      <FormGcr
        formId={gcrApi.formId}
        onFinish={gcrApi.onFinish}
        {...formProps}
      />
    </PageWithBreadcrumbTemplate>
  )
}
